<template>
  <!-- card del riquadro "Riepilogo" (slot "cards" di SupplyRiepilogoSection): è una cella della sua griglia -->
  <div class="storno-card" :class="cardClass">
    <span class="storno-label">
      <i class="pi pi-undo"></i>
      Storni
    </span>
    <span class="storno-value">
      <span v-if="loading" class="storno-muted">
        <i class="pi pi-spin pi-spinner"></i> Caricamento...
      </span>
      <span v-else-if="!richiesta" class="storno-muted">Nessuna richiesta</span>
      <span v-else-if="isStornato" class="storno-ok-text">{{ testoStornato }}</span>
      <span v-else>Richiesta storno fatta il {{ formatDate(richiesta.creation_time) }}</span>
    </span>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "FatturaStornoCard",

  props: {
    richiesta: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    isStornato() {
      return Number(this.richiesta?.used ?? 0) > 0;
    },
    testoStornato() {
      return this.richiesta?.data_storno
        ? `Stornato il ${this.formatDate(this.richiesta.data_storno)}`
        : "Stornato";
    },
    cardClass() {
      if (this.loading || !this.richiesta) {
        return null;
      }
      return this.isStornato ? "storno-card--ok" : "storno-card--warning";
    },
  },

  methods: {
    formatDate(value) {
      const m = moment(value);
      return m.isValid() ? m.format("DD/MM/YYYY HH:mm") : value;
    },
  },
};
</script>

<style scoped>
.storno-card {
  display: flex;
  flex-direction: column;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 1rem 1.1rem;
}

.storno-card--warning {
  background: #fff7ed;
  border-color: #fdba74;
}

.storno-card--ok {
  background: #f0fdf4;
  border-color: #86efac;
}

.storno-label {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  color: #64748b;
  font-size: 0.85rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.storno-value {
  color: #0f172a;
  font-size: 1.05rem;
  font-weight: 600;
  word-break: break-word;
}

.storno-muted {
  color: #94a3b8;
  font-weight: 500;
}

.storno-ok-text {
  color: #15803d;
}
</style>
